import React from 'react';
import { useTranslation } from 'react-i18next';
import { Text, ITypes } from 'view/atoms';
import * as S from './LabelMobile.styles';

type ILabelProps = ITypes & {
  isOnDiscountPage?: boolean;
  isExpired?: boolean;
  isCheckRelevance?: boolean;
  isNew?: boolean;
};

export const LabelMobile = ({
  kind,
  color,
  isOnDiscountPage,
  isCheckRelevance,
  isExpired,
  isNew,
}: ILabelProps) => {
  const { t } = useTranslation();

  return (
    <S.LabelMobileStyle
      isOnDiscountPage={isOnDiscountPage}
      isExpired={isExpired}
      isCheckRelevance={isCheckRelevance}
      isNew={isNew}
    >
      {isExpired && (
        <Text kind={kind} color={color || 'white'}>
          {t('card.expired')}
        </Text>
      )}
      {isNew && (
        <Text data-testid='label-new' kind={kind} color={color || 'white'}>
          {t('card.new')}
        </Text>
      )}
      {isCheckRelevance && (
        <Text kind={kind} color={color || 'white'}>
          {t('card.checkRelevance')}
        </Text>
      )}
    </S.LabelMobileStyle>
  );
};
